import { openModal } from '@core/components/ModalStack';
import { EditNotesModalProps } from './EditNotesModal';

export async function openEditNotesModal(props: EditNotesModalProps) {
  const { EditNotesModal } = await import('./EditNotesModal');

  openModal(EditNotesModal, props);
}
